import React from "react";

type LazyImport<T extends React.ComponentType<any>> = () => Promise<{ default: T }>;

const hasRetriedChunkLoadKey = "has-retried-chunk-load";

function isChunkLoadError(error: unknown) {
  if (!(error instanceof Error)) return false;

  return (
    error.name === "ChunkLoadError" ||
    (error.name === "SyntaxError" && /Unexpected token '<'/i.test(error.message)) ||
    /Loading chunk \d+ failed/i.test(error.message) ||
    /Failed to fetch dynamically imported module/i.test(error.message)
  );
}

export default function lazyWithRetry<T extends React.ComponentType<any>>(importComponent: LazyImport<T>) {
  return React.lazy(() =>
    importComponent()
      .then(component => {
        sessionStorage.removeItem(hasRetriedChunkLoadKey);
        return component;
      })
      .catch(error => {
        const hasRetried = sessionStorage.getItem(hasRetriedChunkLoadKey) === "true";

        if (isChunkLoadError(error) && !hasRetried) {
          sessionStorage.setItem(hasRetriedChunkLoadKey, "true");
          window.location.reload();
          return new Promise<{ default: T }>(() => undefined);
        }

        throw error;
      }),
  );
}
